/* tslint:disable */

/**
 */
export class Energy {
    ID_COOLING_FAMILY?: number;
    ID_FAMILY?: number;
    ID_EQUIPSERIES?: number;
    STD?: number;
    LABEL?: string;
    CONSTRUCTOR?: string;
    EQP_LENGTH?: string;
    EQP_WIDTH?: string;
    DISPLAY_LENGTH?: string;
    DISPLAY_WIDTH?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/energy.ts